// 注意：这里引入的本地翻译文件名是'_'连接
import enUS from '@/locales/en-US.json';
import zhCN from '@/locales/zh-CN.json';
import { Locales, LOCALES_MAP } from '@/i18n';
import type { Translation } from '@/typings/i18n';

import i18n from '@/i18n';

/** 转换翻译数据结构 */
export function transformTranslateData(originalData: Translation[]) {
  const localeMap = {};

  Object.values(Locales).forEach((locale) => {
    originalData.forEach((item) => {
      if (!localeMap[locale]) {
        localeMap[locale] = {};
      }
      localeMap[locale][item.text_id] = item[LOCALES_MAP[locale]];
    });
  });

  return localeMap;
}

/** 读取本地Local文件夹下的翻译数据 */
export function readTranslateFile() {
  return {
    [Locales.zhCN]: zhCN,
    [Locales.enUS]: enUS,
  };
}

export function transformPageTitle(originTitle: string) {
  const regex = /^(.*?)(\s-\sBlueGrowth\sCloud)$/;
  const match = originTitle.match(regex);

  if (match) {
    const key = match[1]; // 需要翻译的文本部分
    const suffix = match[2]; // 保留原始字符串中的 "- BlueGrowth Cloud" 部分
    const translated = i18n.t(key); // 使用 i18n.t() 获取翻译后的文案

    // 拼接翻译后的文本和原始字符串中的 "- BlueGrowth Cloud" 部分
    return `${translated}${suffix}`;
  }

  return originTitle; // 如果没有匹配，返回原始字符串
}

/** 处理对象的value，给每一个value包裹t方法 */
export function transformObjectValue(obj: Record<string, string>) {
  const result = {};

  Object.keys(obj).forEach((key) => {
    result[key] = typeof obj[key] === 'string' ? i18n.t(obj[key]) : obj[key];
  });

  return result;
}
